<template>
  <div class="increaseCase">
    <a-spin tip="Loading..." :spinning="spinning">
      <div class="spin-content">
        <div style="margin:18px 0">
          <Breadcrumb :breadcrumb="breadcrumb" />
        </div>
        <div style="padding:20px 29px 0;background: #fff;border-radius:2px;">
          <cardTitle title="个案基本信息" />
          <div style="margin-top:18px;">
            <CaseBaseForm
              ref="caseBaseForm"
              :initData="{ ...assitTargetInfo, assitLog }"
              :checkDisplay="checkDisplay"
              :checkDisabled="checkDisabled"
              :minzuList="minzuList"
              :pageType="pageType"
            ></CaseBaseForm>
            <FamilyForm
              ref="familyForm"
              :initData="{ ...assitTargetInfo, projectRelate }"
              :checkDisplay="checkDisplay"
              :checkDisabled="checkDisabled"
              :pageType="pageType"
            />
          </div>
        </div>
        <!--        <div style="padding:20px 29px;background: #fff;border-radius:2px;margin-top:11px;">-->
        <!--          <cardTitle title="家庭信息"/>-->
        <!--          <div style="margin-top:18px;">-->
        <!--            <FamilyForm-->
        <!--              ref="familyForm"-->
        <!--              :initData="{...assitTargetInfo,projectRelate}"-->
        <!--              :checkDisplay="checkDisplay"-->
        <!--              :checkDisabled="checkDisabled"-->
        <!--            />-->
        <!--          </div>-->
        <!--        </div>-->
        <div
          class="formButton"
          style="margin-top:20px;text-align: right"
          v-if="checkDisplay('button')"
        >
          <a-button
            type="primary"
            :style="{ marginLeft: '8px' }"
            @click="onSubmit"
            v-if="checkDisplay('submit')"
          >提交</a-button>
          <a-button
            :style="{ marginLeft: '8px' }"
            @click="goToHistory"
            v-if="checkDisplay('cancel')"
          >取消</a-button>
        </div>
      </div>
    </a-spin>
  </div>
</template>

<script>
import cardTitle from '../components/cardTitle'
import Breadcrumb from '@/components/breadcrumb'
import CaseBaseForm from '../components/caseBaseForm'
import FamilyForm from '../components/familyForm'
import leaderSelect from '@/components/leaderSelect'
import { service } from './service'

export default {
  name: 'Index',
  components: {
    cardTitle,
    Breadcrumb,
    CaseBaseForm,
    FamilyForm,
    leaderSelect
  },
  data() {
    return {
      spinning: false,
      // assitPeopleInfoFlag: false, // 是否已存在帮扶对象信息
      // assitPeopleInfo: {}, // 帮扶对象具体信息
      pageType: 'increase', // 拟稿
      projectRelate: [], // 项目关联
      assitLog: [], // 帮扶日志
      assitTargetInfo: {}, // 表单默认数据
      // processConfigType: 'individualCase', // 流程类型
      processData: {}, // 页面带过来的流程关键数据
      breadcrumb: [
        {
          // 面包屑
          title: '帮扶对象',
          path: ''
        },
        {
          title: '帮扶对象列表',
          path: '/assit/assitTarget'
        },
        {
          title: '帮扶对象详情',
          path: ''
        }
      ],
      minzuList: []
    }
  },
  created() {
    if (this.$route.query && this.$route.query.pageType) {
      // 判断页面跳转带过来的页面类型的值
      if (this.$route.query.pageType === 'increase') {
        // 发起
        this.pageType = 'increase'
      } else if (this.$route.query.pageType === 'view') {
        // 退回拟稿
        this.pageType = 'view'
      } else if (this.$route.query.pageType === 'edit') {
        // 退回拟稿
        this.pageType = 'edit'
      }
      this.processData = this.$route.query.processData
        ? JSON.parse(this.$route.query.processData)
        : {}
    }
  },
  mounted() {
    this.spinning = true
    if (this.pageType === 'edit' || this.pageType === 'view') {
      // 拟稿
      service
        .needHelpPerson({ need_help_person_number_id: this.processData.need_help_person_number_id })
        .then((response) => {
          // 查询后台是否有该对象的信息
          // if (this.pageType === 'view') {
          this.getProject(this.processData.need_help_person_number_id) // 获取关联的项目
          // }
          if (response && response.length > 0) {
            // 判断能不能查大帮扶对象的信息
            this.assitTargetInfo = this._.cloneDeep(response[0] || {})
            this.spinning = false
          }
        })
    } else if (this.pageType === 'increase') {
      this.spinning = false
      this.assitTargetInfo = {
        need_help_person_number_id: this.processData.need_help_person_number_id
      }
    }

    this.$store.dispatch('GetNational').then(response => {
      this.minzuList = response
    })
  },
  methods: {
    // 判断是否展示,返回true就展示，false不展示
    checkDisplay(type) {
      if (this.pageType === 'view') {
        // 当能查到用户信息时,无论什么页面类型，这些都不展示
        switch (type) {
          case 'increasePeople':
            return false // 新增家庭成员按钮不展示
          case 'need_help_person_registered_address_detailed': // 详细地址
            return false
          case 'need_help_person_current_address_detailed':
            return false
          case 'detailAddress':
            return false // 项目选择提醒
          case 'button':
            return false // 只读时按钮不生成
        }
      }
      // else if (this.pageType === 'increase') {
      //   switch (type) {
      //     case 'itemRelated':
      //       return false
      //       case 'assitLog':
      //         return false
      //   }
      // }
      return true
    },
    // 判断每个控件是否只读，不能更改，如果只读返回true，否则返回false
    checkDisabled(type) {
      if (this.pageType === 'view') {
        switch (
        type // 审批控件
        ) {
          default:
            return true
        }
      } else if (this.pageType === 'increase' || this.pageType === 'edit') {
        switch (
        type // 审批控件
        ) {
          default:
            return false
        }
      }
      // else if (this.pageType === 'edit') {
      //   switch (type) {
      //     case 'need_help_person_number_id':// edit的时候，身份证号不能编辑
      //       return true
      //     default:
      //       return false
      //   }
      // }
    },
    // 获取帮扶对象项目关联情况
    getProject(idCard) {
      // 项目关联
      // service.getTaskForProject({ need_help_person_number_id: idCard }).then(response => {
      //   this.projectRelate = response || []
      // })
      service.getTaskForUnProject({ need_help_person_number_id: idCard }).then((response) => {
        this.assitLog = response || []
        this.assitLog = this.assitLog.map(item => {
            if (item.process_base_work_number === this.processData.process_base_work_number) {
                this.$set(item, 'current', true)
            }
            return item
        })
      })
    },
    // 表单发起提交
    onSubmit() {
      let message = '新增成功'
      const baseData = this.$refs.caseBaseForm.onSubmit()
      const familyData = this.$refs.familyForm.onSubmit()
      if (this.pageType === 'increase') {
        message = '新增成功'
        // baseData.need_help_person_type = '个人'
      } else if (this.pageType === 'edit') {
        message = '编辑成功'
      }
      if (baseData) {
        service
          .increaseAssitTarget({ baseData, familyData, assitTargetInfo: this.assitTargetInfo })
          .then((response) => {
            this.$notification.success({
              message: message
            })
            this.spinning = false
            this.$router.push({ path: '/assit/assitTarget' })
          })
      }
    },
    // 取消返回上一页
    goToHistory() {
      this.$router.go(-1) // 返回上一层
    }
  }
}
</script>

<style scoped lang="less">
@import "../../style.less";
</style>
